<template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
    <template v-if="isLoading">
      <div v-for="item in DEFAULT_PAGE_LIMIT" :key="item">
        <UiSkeleton class="aspect-square w-full !rounded-2xl" />
        <UiSkeleton class="my-2 h-6 w-40" />
        <UiSkeleton class="my-2 h-6 w-10" />
      </div>
    </template>
    <template v-else>
      <ProductListCard v-for="product in products" :key="product.id" :product="product" />
    </template>
  </div>
</template>

<script setup lang="ts">
import type { ProductListProps } from '~/components/ProductList/types';

defineProps<ProductListProps>();
</script>
